import { FC, useState } from 'react';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import { getPartnersFromOldOperation } from '../../utils/getPartnersFromOldOperation';
import RenumerationOperationTableRow from './RenumerationOperationTableRow';

const RenumerationOperationTableBody: FC = () => {
  const { data } = useOperationDetailsPage();

  const partners = data.isOldOperation
    ? getPartnersFromOldOperation(data.operation)
    : data.partners;

  const hasData = partners?.length > 0;

  const [expandedPartners, setExpandedPartners] = useState<Set<string>>(
    new Set()
  );

  const handleToggleExpand = (partnerId: string) => {
    setExpandedPartners((prev) => {
      const next = new Set(prev);
      if (next.has(partnerId)) {
        next.delete(partnerId);
      } else {
        next.add(partnerId);
      }
      return next;
    });
  };

  const rows = partners!.map((partner, index) => (
    <RenumerationOperationTableRow
      // eslint-disable-next-line react/no-array-index-key
      key={`partner-row-${index}`}
      index={index}
      partner={partner}
      isExpanded={expandedPartners.has(partner._id)}
      onToggleExpand={handleToggleExpand}
    />
  ));

  return <TableBody hasData={hasData} content={rows} noDataMessage="" />;
};

export default RenumerationOperationTableBody;
